import React from "react";
import { createRoot } from "react-dom/client";
import { render } from "react-dom";
import App from "./App";
import HttpsRedirect from "react-https-redirect";

const APP = (
  <HttpsRedirect>
    <App />
  </HttpsRedirect>
);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

if (rootElement.hasChildNodes()) {
  render(APP, rootElement);
} else {
  root.render(APP);
}
